import {
    FETCH_POSTS,
    FETCH_POST,
    CREATE_POST,
    UPDATE_POST,
    REMOVE_POSTS
} from '../actions/types';

const INIT_STATE = {
    posts: [],
    currentPost: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_POSTS:
            return {
                ...state,
                posts: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 30, 10)
                }
            };
        case FETCH_POST:
            return { ...state, currentPost: action.payload || null };
        case CREATE_POST:
            return { ...state, currentPost: action.payload || null };
        case UPDATE_POST:
            return {
                ...state,
                currentPost: action.payload || null,
                posts: state.posts.map(post => post.id === action.payload?.id ? action.payload : post)
            };
        case REMOVE_POSTS:
            return {
                ...state,
                posts: state.posts.filter(post => !action.payload.includes(post.id))
            };
        default:
            return state;
    }
};
